import React, { useContext } from 'react';
import SocialProofingMessage from './components/SocialProofingMessage';
import ProductPageContext from '../../contexts/ProductPageContext';

export default function SocialProofing() {
  const ProductPageState = useContext(ProductPageContext);
  const { collectionData } = ProductPageState;
  const { hasSocialProofingEnabled, joinedKics, brand } = collectionData;

  return hasSocialProofingEnabled ? (
    <SocialProofingMessage
      productIdParam={joinedKics}
      eventType="views"
      timeWindow={60}
      parentBrand={brand}
    />
  ) : null;
}
